import { DialogService } from 'primeng/dynamicdialog';

import { Injectable } from '@angular/core';

import { MarkReturnedSensorsComponent } from './mark-returned-sensors.component';
import { Race } from 'src/app/models/race';

@Injectable({
  providedIn: 'root'
})
export class MarkReturnedSensorsService {

  constructor(
    private dialogService: DialogService
  ) { }

  openReturnSensorsDialog(race: Race) {
    this.dialogService.open(MarkReturnedSensorsComponent, {
      header: 'Отметка возвращённых датчиков',
      width: window.innerWidth < 800 ? '100%' :'800px',
      data: {
        race,
      }
    });
  }
}
